export function numericKeySorter(items: any[], key: string, order = 'desc'): any[] {
    items.sort((a, b) => {
        if (isNaN(a[key]) && isNaN(b[key])) return 0;
        if (isNaN(a[key])) return -1;
        if (isNaN(b[key])) return 1;
        return order === 'desc' ? b[key] - a[key] : a[key] - b[key];
    });

    return items;
}

export function stringKeySorter(items: any[], key: string, order = 'desc') {
    return items.sort((a, b) =>
        order === 'desc' ? alphaNumSort(a[key], b[key]) : alphaNumSort(b[key], a[key]));
}

export function alphaNumSort(as, bs) {
    // tslint:disable-next-line
    let a, b, a1, b1, i = 0, L, rx = /(\d+)|(\D+)/g, rd = /\d/;
    if (isFinite(as) && isFinite(bs)) return as - bs;
    a = String(as).toLowerCase();
    b = String(bs).toLowerCase();
    if (a === b) return 0;
    if (!(rd.test(a) && rd.test(b))) return a > b ? 1 : -1;
    a = a.match(rx);
    b = b.match(rx);
    L = a.length > b.length ? b.length : a.length;
    while (i < L) {
        a1 = a[i];
        b1 = b[i++];
        if (a1 !== b1) {
            if (isFinite(a1) && isFinite(b1)) {
                if (a1.charAt(0) === '0') a1 = '.' + a1;
                if (b1.charAt(0) === '0') b1 = '.' + b1;
                return a1 - b1;
            }
            else return a1 > b1 ? 1 : -1;
        }
    }
    return a.length - b.length;
}
